import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs';
import * as globalAdd from '../../../connectionString';
import { PatientData } from '../models/PatientData.model';

@Injectable()
export class PatientServiceService {
invokeFirstComponentFunction = new EventEmitter();
subsVar: Subscription;
invokeAutoAdjust = new EventEmitter();
contentHeight: Subscription;
invokeAutoAdjustApp = new EventEmitter();
contentHeightApp: Subscription;

  onFirstComponentButtonClick() {
    this.invokeFirstComponentFunction.emit();
  }

  autoAdjustContent(){
    this.invokeAutoAdjust.emit();
  }

  autoAdjustContentApp(){
    this.invokeAutoAdjustApp.emit();
  }

  constructor(private http: HttpClient) { }
  changePassword(oldPwd: string, newPwd: string, rePwd: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/PA/Home/changePassword', { oldPwd: oldPwd, newPwd: newPwd, rePwd: rePwd });
  }

  getCountriesAndStates() {
    return this.http.get(globalAdd.Paneladdress + 'api/PA/Home/getCountriesAndStates');
  }

  getNotification() {
    return this.http.get(globalAdd.Paneladdress + 'api/PA/Notification/getNotifications');
  }

  removeNotification(delNots: any[]) {
    return this.http.get(globalAdd.Paneladdress + 'api/PA/Notification/removeNotification?notificationIds=' + delNots );
  }

  updatePatientProfile(patientData: PatientData) {
    return this.http.post(globalAdd.Paneladdress + 'api/PA/Home/updatePatientProfile', patientData );
  }

  uploadPatientPhoto(File: File) {
    const data: FormData = new FormData();
    data.append("Photo", File);
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Content-Type', 'multipart/form-data');
    return this.http.post(globalAdd.Paneladdress + 'api/Patient/uploadPatientPhoto', data, { headers, reportProgress: true, observe: 'events' });
  }

  getPatientProfileData() {
    return this.http.get(globalAdd.Paneladdress + 'api/PA/Home/getPatientProfileData');
  }

  getPatientCaseList() {
    return this.http.get(globalAdd.Paneladdress + 'api/PA/Home/getPatientCaseList');
  }

  getPatientOtherData() {
    return this.http.get(globalAdd.Paneladdress + 'api/PA/Home/getPatientOtherData');
  }

  getPatientScheduledInfo(sId) {
    return this.http.get(globalAdd.Paneladdress + 'api/PA/Home/getPatientScheduledInfo?sId=' + sId);
  }

  getPatientCaseCodes(sId, index) {
    return this.http.get(globalAdd.Paneladdress + 'api/PA/Home/getPatientCaseCodes?sId='+sId+'&index='+ index);
  }

  getPatientPdfData(sId) {
    return this.http.get(globalAdd.Paneladdress + 'api/PA/Home/getPatientPdfData?scheduleId='+ sId );
  }

  getDoctorsForSchedule() {
    return this.http.get(globalAdd.Paneladdress + 'api/PA/Appointment/getDoctorsForSchedule');
  }

  feedbackFromPatient(scheduleId,comments,rate,doctorId,EaHospId){
    return this.http.post(globalAdd.Paneladdress + 'api/PA/Feedback/feedbackFromPatient', { scheduleId: scheduleId, comments: comments,rate:rate,doctorId:doctorId,EaHospId:EaHospId });
  }

  getSinglePdf(id){
    return this.http.get(globalAdd.Paneladdress + 'api/PA/Home/getSinglePdf?id='+id);
  }

}
